import { Component, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ACCOUNT_TYPES } from './bank-account-info.constants';
import { routingNumberValidator } from '../../../utils/validators';
import { BANK_ACC_NO_REGEX, BANK_ROUTING_NO_REGEX } from '../../../utils/constants';
import { PaymentService } from '../../../services/payment/payment.service';
import { IBankAccountFormGroup } from '../../../interfaces/IPayments';

@Component({
  selector: 'app-bank-account-info',
  templateUrl: './bank-account-info.component.html',
  styleUrl: './bank-account-info.component.scss'
})
export class BankAccountInfoComponent {
  bankAccountForm!: FormGroup<IBankAccountFormGroup>;
  accountTypes = ACCOUNT_TYPES;
  constructor(private paymentService: PaymentService) {}

  ngOnInit(): void {
    this.bankAccountForm = this.paymentService.bankAccForm;
  }

}
